import { render, staticRenderFns } from "./ReportDiscount.vue?vue&type=template&id=345b053a"
import script from "./ReportDiscount.vue?vue&type=script&lang=js"
export * from "./ReportDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports